import AuthLogout from './auth-logout';

export default AuthLogout;
